import { render } from "./CoachItem.vue?vue&type=template&id=3c6e4c51&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=3c6e4c51&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c6e4c51"

export default script